import React from 'react';

import { LoadingPage } from 'components/LoadingPage';
import NotFoundPage from 'components/NotFoundPage';
import useFeatureFlag from 'data/react-query/queries/useFeatureFlag';
import { IS_PAYMENT_LISTING_ENABLED } from 'data/feature-flags/constants';
import { getUser } from 'utils/user';

const withPaymentListingFlag = (WrappedComponent) => (props) => {
  const { data: isPaymentListingEnabled, isLoading } = useFeatureFlag(
    {
      key: IS_PAYMENT_LISTING_ENABLED,
      defaultValue: false,
    },
    undefined,
    getUser().user_id?.toString(),
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isPaymentListingEnabled) {
    return <NotFoundPage />;
  }

  return <WrappedComponent {...props} />;
};

export default withPaymentListingFlag;
